<template>
  <router-view v-slot="{ Component }">
    <!-- 首页缓存 -->
    <keep-alive include="Home">
      <component :is="Component" v-if="windowW < 850" />
    </keep-alive>
    <component :is="Component" v-if="windowW > 850" />
  </router-view>
</template>

<script lang="ts">
import { useRouter, useRoute, LocationQueryValue } from "vue-router";
export default {
  name: "appMain",
  setup() {
    // 判断是pc端还是移动端
    const windowW = window.innerWidth;
    return {
      windowW,
    };
  },
};
</script>
<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
